{
  "serviceForms": {
    "giftCardInformationForm": {
      "labels": {
        "availableGiftCardValue": "Gift card value"
      }
    },
    "manageCompensationForm": {
      "error": {
        "cancelled": "This compensation is cancelled. Please contact our customer service.",
        "converted": "You have chosen to receive this compensation as cash. Please note that the payment usually takes 3–14 business days.",
        "expired": "Unfortunately, you can no longer manage this compensation.",
        "locked": "This compensation is currently locked. Please contact our customer care for further assistance.",
        "notFound": "We couldn't find the compensation. Please check the entered login reference and PIN code. If you need help, please contact our customer service.",
        "requestError": "We couldn't process your request. Please try again later."
      },
      "fields": {
        "giftCardId": {
          "label": "Login reference",
          "pattern": "The login reference is not in the correct format.",
          "required": "The login reference is required."
        },
        "giftCardPin": {
          "label": "PIN code",
          "pattern": "The PIN code is not in the correct format.",
          "required": "PIN code is required."
        }
      },
      "labels": {
        "convertToCash": "Provide your bank details",
        "expiresOn": "Choose your form of compensation by:"
      },
      "steps": {
        "giftCardConversion": {
          "confirmationLabel": "Please enter the PIN code to confirm that the above details are correct and you wish to receive your compensation as cash.",
          "formDescription": "You can choose your preferred form of compensation."
        },
        "giftCardInformation": {
          "title": "About your compensation"
        },
        "giftCardVerification": {
          "footnotes": [
            "You can find the <strong>login reference</strong> and <strong>PIN code</strong> in the email sent to you, either by us or the person who gifted it to you."
          ],
          "title": "Manage your compensation"
        }
      }
    }
  }
}
